"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionPopupCard = void 0;
var Card_1 = __importDefault(require("@mui/material/Card"));
var styles_1 = require("@mui/material/styles");
exports.TransactionPopupCard = (0, styles_1.styled)(Card_1.default)({
    boxShadow: 'rgb(0 0 0 / 20%) 0px 5px 5px -3px, rgb(0 0 0 / 14%) 0px 8px 10px 1px, rgb(0 0 0 / 12%) 0px 3px 14px 2px',
});
